import styled, { css } from 'styled-components';

import { DropDown } from '../index';

export const DROPDOWN_COMMON_STYLES = css`
  border-radius: 4px;
  border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg0[3]};

  .TrekDropDownItem-root {
    .TrekDropDownItem-label {
      background-color: ${({ theme }): string => theme.admanColors!.gray.light.bg0[0]};
    }
  }

  button {
    align-items: center;
  }
`;

export const Wrapper = styled(DropDown)`
  width: 216px;
  ${DROPDOWN_COMMON_STYLES}
`;
